// Navigation related
export const FEEDBACK_TEXT = 'Provide Feedback';
export const REPORT_ISSUE = 'Report Issue';

// UI messages
export const NO_RESULT_MESSAGE = 'No results';
export const REMEMBER_TO_SAVE_WARN_MSG = "Your work hasn't been saved. Please save your changes before continuing!";
export const SAVE_BTN_CLICKED = 'Save Btn Clicked';
export const CONFIRMATION_YES_BUTTON_TEXT = 'Yes, Delete';
export const CONFIRMATION_NO_BUTTON_TEXT = 'No, Cancel';

// Dev Tool - Kbar
export const KBAR_SECTION_NAME = 'Feature Gating';
export const LOCAL_STORAGE_PREFIX = 'featureGating-';

// Error messages
export const UNEXPECTED_ERROR = 'Unexpected error. Please report the issue.';
export const CUT_TT = 'Cut a Trouble Ticket';
export const FETCH_AMT_INBOUND_OUTBOUND_MAPPING_FAILED = 'Failed to fetch AMT inbound outbound date mapping.';
export const CONTACT_EMAIL = 'ihm-assortment-tech@amazon.com';

// Agile Upload Col related
export const COL_STORE_ID = 'storeId';
export const COL_ZONE = 'zone';
export const COL_LIVE_DATE = 'liveDate';
export const COL_ASIN = 'asin';
export const COL_FACE_UNITS = 'faceUnits';

// Time constants
export const INDEFINITE_TIME = 32506855650000;
